import { FormattedMessage } from 'react-intl'
import CtaButton from '@components/CtaButton/CtaButton'

import x from '@static/vectors/icon-x.svg'
import instagram from '@static/vectors/icon-insta.svg'
import linkedin from '@static/vectors/icon-linkedin.svg'
import './SocialLinks.css'

export default function SocialLinks({
  darkTheme = false
}: {
  darkTheme?: boolean
}) {
  return (
    <nav
      className={`${!darkTheme ? 'scheme-ligth' : 'scheme-dark'} social-links`}
    >
      <div className="social-links-wrapper">
        <FormattedMessage id="social-links.follow" />
        <a target="_blank" href="https://x.com/datalab_adgtl" rel="noreferrer">
          <img src={x} alt="x icon" />
          <span>@datalab_adgtl</span>
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/datalab_by_adigital/"
          rel="noreferrer"
        >
          <img src={instagram} alt="instagram icon" />
          <span>@datalab_by_adigital</span>
        </a>
        <a
          target="_blank"
          href="https://linkedin.com/company/datalab-by-adigital/"
          rel="noreferrer"
        >
          <img src={linkedin} alt="linkedin icon" />
          <span>@datalab-by-adigital</span>
        </a>
      </div>
      <CtaButton />
    </nav>
  )
}
